var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"viewBox":"0 0 24 24","id":"icon--hr"}},[_c('path',{attrs:{"d":"M5 13a1 1 0 010-2h14a1 1 0 010 2H5z"}})])}
var staticRenderFns = []

export { render, staticRenderFns }